export const ViewModeConstants = {
    DATA_CARDS: 'cards',
    TABLE: 'table'
};
